export default __webpack_public_path__ + "987268ca94d581b6f8935c8097a6b397.png";